import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable, of } from 'rxjs';
//import { catchError, map, tap } from 'rxjs/operators';
//import Constants from '../constants/constants';

@Injectable()
export class LookupApiService extends BaseApiService {

  url = `${this.baseUrl}/lookup`;

  getConstants(): Observable<any> {
    return this.http.get(`${this.url}/constants`);
  }

  /*loadConstants(): Observable<boolean> {
    return this.getConstants().pipe(
      tap(res => Object.assign(Constants, res)),
      map(() => true),
      catchError(err => {
        console.error(err);
        return of(false);
      })
    );
  }*/
}
